import {
  Button,
  Disclaimer,
  TableCell,
  TimeIcon,
  Typography,
} from '@libs/components';
import styled, { css } from 'styled-components';

type ReceiveTimerWrapperProps = {
  hasDisclaimer: boolean;
};

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding: 2rem 2rem;
  ${({ theme }) => theme.media.tablet`
  padding: 2rem 3.6rem 3.6rem 3.6rem;

  `};
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.x5};

  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  margin-bottom: 2.4rem;
`;

export const CurrencyDetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1.6rem 2rem;
  margin: 0.4rem;
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
`;

export const CurrencyTextsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 0.4rem;
  justify-content: center;
`;

export const AmountText = styled(Typography)`
  margin: 0 0.4rem 0 0.8rem;
`;

export const CustomButton = styled(Button)`
  width: fit-content;

  padding: 1rem;
`;

export const DetailsFieldWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  :first-child {
    align-items: flex-start;
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.borders.default};
  margin: 1.6rem 0;
`;

export const RecieveTimeWrapper = styled.div<ReceiveTimerWrapperProps>`
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  border: 0.05rem solid ${({ theme }) => theme.colors.borders.default};
  background-color: ${({ theme, hasDisclaimer }) =>
    hasDisclaimer
      ? theme.colors.surface.default
      : theme.colors.surface.interactiveDefault};
  border-radius: ${({ theme }) => theme.borderRadius.high};
  width: 100%;
  padding: 1.2rem 1.6rem;

  box-shadow: ${({ theme, hasDisclaimer }) =>
    hasDisclaimer ? theme.shadows.md : ''};
`;

export const DisclaimerAndReceiveTimerWrapper = styled.div<ReceiveTimerWrapperProps>`
  ${({ theme, hasDisclaimer }) =>
    hasDisclaimer
      ? css`
          background-color: ${theme.colors.surface.interactiveDefault};
          border-radius: ${theme.borderRadius.high};
          overflow: hidden;
        `
      : ''}
  margin-bottom: 2.4rem;
`;

export const RecieveTimeLabelWrapper = styled.div`
  display: flex;
  align-items: flex-end;

  gap: 0.4rem;
`;

export const FooterDetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const RecieveDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  padding: 1.6rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  margin-bottom: 2.4rem;
`;

export const DetailFieldsWrapper = styled.div`
  padding: 2rem;
`;

export const Img = styled.img`
  width: 3.2rem;
`;

export const CustomTableCell = styled(TableCell)`
  flex-direction: row-reverse;

  .icon-wrapper {
    margin-right: 0;
    margin-left: 0.4rem;
  }
  .text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: end;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ReceiveDetailsTableCell = styled(TableCell)`
  .TableCellDescription {
    max-width: 23.75rem;
    overflow: hidden;
  }
  .TableCellTitle {
    font-family: ${({ theme }) => theme.fonts.primaryMedium};
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;

export const CustomTypography = styled(Typography)`
  margin-left: 0.8rem;
  margin-right: 0.4rem;
  line-height: 2.8rem;
`;

export const CustomTimeIcon = styled(TimeIcon)`
  fill: ${({ theme }) => theme.colors.borders.highlight};
  width: 2rem;
  .inner-stroke {
    stroke: ${({ theme }) => theme.colors.text.interactive};
  }
`;

export const CustomDisclaimer = styled(Disclaimer)`
  border-radius: 0;
  border: none;
  padding: 2rem 1.6rem;
`;
